export default "__VITE_ASSET__a95c3f41__"